export default {
  setWaste(state, objectFromWaste){
      state.wastes = objectFromWaste;
    }
  }